var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.058,
    height: 16.883,
    viewBox: "0 0 17.058 16.883",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "review_14990739",
    transform: "translate(-1.743 -2.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47118",
    "data-name": "Path 47118",
    d: "M14.178,19.673H21.85a.276.276,0,0,0,0-.551H14.178a.276.276,0,1,0,0,.551Z",
    transform: "translate(-8.621 -12.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47119",
    "data-name": "Path 47119",
    d: "M14.178,28.674H21.85a.276.276,0,0,0,0-.551H14.178a.276.276,0,1,0,0,.551Z",
    transform: "translate(-8.621 -18.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47120",
    "data-name": "Path 47120",
    d: "M18.831,37.4a.276.276,0,0,0-.276-.276H14.178a.276.276,0,0,0,0,.551h4.377A.276.276,0,0,0,18.831,37.4Z",
    transform: "translate(-8.621 -25.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47121",
    "data-name": "Path 47121",
    d: "M17.895,13.1l-1.806-.262a7.3,7.3,0,0,0,.7-3.14A7.393,7.393,0,1,0,3.243,13.8L2.022,16.713a.274.274,0,0,0,.254.383.3.3,0,0,0,.108-.022L5.3,15.853a7.373,7.373,0,0,0,6.317.9L11.435,17.8a.755.755,0,0,0,1.1.8l1.693-.891a.21.21,0,0,1,.19,0l1.7.891a.729.729,0,0,0,.353.088.773.773,0,0,0,.444-.143.759.759,0,0,0,.3-.742l-.325-1.886a.2.2,0,0,1,.061-.182l1.37-1.337a.756.756,0,0,0-.419-1.288Zm-8.5,3.441a6.789,6.789,0,0,1-3.907-1.23.276.276,0,0,0-.265-.028L2.791,16.305l1.017-2.432a.282.282,0,0,0-.028-.265A6.84,6.84,0,1,1,16.235,9.7a6.732,6.732,0,0,1-.549,2.685L15,11a.756.756,0,0,0-1.357,0L12.8,12.715a.211.211,0,0,1-.154.113l-1.9.276a.754.754,0,0,0-.416,1.288l1.37,1.337a.211.211,0,0,1,.058.182l-.039.223A6.647,6.647,0,0,1,9.395,16.545Z",
    stroke: "#000",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/Review.ac42d38dae6e9a155bf3d1cbdc53631e.svg";
export { ForwardRef as ReactComponent };